import { createReducer } from '@reduxjs/toolkit';
import { ApiEndpointSetting } from 'backend';
import { useSelector } from 'react-redux';
import { updatePage } from '../commons';
import { RootState } from '../store';

type ApiEndpointState = ApiEndpointSetting | null;

export const apiEndpointReducer = createReducer<ApiEndpointState>(
  null,
  (builder) => {
    builder.addCase(updatePage, (_, action) => {
      const { apiEndpoint } = action.payload;
      return apiEndpoint;
    });
  },
);

// selector
export const useApiEndpoint = (): ApiEndpointState =>
  useSelector<RootState, ApiEndpointState>(
    (rootState) => rootState.apiEndpoint,
  );
